import { Component, Story, Knobs } from './DocTypes';

const PlaygroundStoryKnobs: Knobs = {
  header: {
    default: 'Tooltip',
    editor: 'textbox',
    delimiter: '\n    ',
  },
  content: {
    default:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dictum nisl blandit nunc maximus, ut placerat odio sodales. Donec fermentum massa id turpis tempor consequat. Nullam imperdiet auctor purus, ac convallis.',
    editor: 'textbox',
    delimiter: '\n    ',
  },
  width: {
    default: '470px',
    editor: 'textbox',
    delimiter: '\n    ',
  },
  background: {
    default: 'light',
    editor: 'dropdown',
    editorOptions: ['light', 'dark'],
    delimiter: '\n    ',
  },
  suppressArrow: {
    default: false,
    editor: 'checkbox',
    delimiter: '\n    ',
  },

  open: {
    editor: 'checkbox',
    default: false,
  },
  dropShadowDisabled: {
    editor: 'checkbox',
    default: false,
  },
  position: {
    default: '',
    editor: 'dropdown',
    editorOptions: [
      '',
      'auto',
      'auto-start',
      'auto-end',
      'bottom',
      'bottom-start',
      'bottom-end',
      'top',
      'top-start',
      'top-end',
      'left',
      'left-start',
      'left-end',
      'right',
      'right-start',
      'right-end',
    ],
    delimiter: '\n    ',
  },
};

const PlaygroundKnobsV3: Knobs = {
  header: {
    default: 'Tooltip',
    editor: 'textbox',
    delimiter: '\n    ',
  },
  headerStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n    ',
  },
  content: {
    default:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dictum nisl blandit nunc maximus, ut placerat odio sodales. Donec fermentum massa id turpis tempor consequat. Nullam imperdiet auctor purus, ac convallis.',
    editor: 'textbox',
    delimiter: '\n    ',
  },
  contentStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n    ',
  },
  containerStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n    ',
  },
  width: {
    default: '470px',
    editor: 'textbox',
    delimiter: '\n    ',
  },
  background: {
    default: 'light',
    editor: 'dropdown',
    editorOptions: ['light', 'dark'],
    delimiter: '\n    ',
  },
  open: {
    editor: 'checkbox',
    default: false,
  },
  tippyProps: {
    editor: 'textbox',
    default: '',
    delimiter: '\n    ',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['', 'desktop', 'mobile'],
    default: '',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['', 'light', 'dark', 'default'],
    default: '',
  },
};

const PlaygroundKnobsV3React: Knobs = {
  ...PlaygroundKnobsV3,
  headerStyle: {
    ...PlaygroundKnobsV3.headerStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  contentStyle: {
    ...PlaygroundKnobsV3.contentStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  containerStyle: {
    ...PlaygroundKnobsV3.containerStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  tippyProps: {
    ...PlaygroundKnobsV3.tippyProps,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'Tooltip playground',
  coreComponent: {
    html: `<div style='text-align: center;'>
    <tag-avatar
      class='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'>
    </tag-avatar>
  </div>
  <tag-tooltip
    tooltip-for='.tooltip-target'{{...knobs}}>
  </tag-tooltip>`,
    knobs: {
      ...PlaygroundStoryKnobs,
    },
  },

  coreComponent_v3: {
    html: `<div style='text-align: center;'>
    <tag-avatar
      class='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'>
    </tag-avatar>
  </div>
  <tag3-tooltip
    tooltip-for='.tooltip-target' {{...knobs}}>

  </tag3-tooltip>`,
    knobs: {
      ...PlaygroundKnobsV3,
    },
  },
  reactWrapper: {
    jsx: `<div>
  <div style={{textAlign: "center"}}>
    <TagAvatar
      className='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'
    />
  </div>
  <TagTooltip
    tooltipFor='.tooltip-target'{{...knobs}}>
  </TagTooltip>
</div>`,
    knobs: {
      ...PlaygroundStoryKnobs,
    },
  },

  reactWrapper_v3: {
    jsx: `<PlaygroundExample />`,
    parentJSX: `PlaygroundExample = () => {
return (
  <div>
  <div style={{textAlign: "center"}}>
    <TagAvatar
      className='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'
    />
  </div>
  <Tag3Tooltip
    tooltipFor='.tooltip-target'{{...knobs}}>
  </Tag3Tooltip>
</div>
)
};`,
    knobs: {
      ...PlaygroundKnobsV3React,
    },
  },
};
const CustomContentStory: Story = {
  title: 'Custom content',
  description: 'A tooltip with custom content',
  coreComponent: {
    html: `<div style='text-align: center;'>
    <tag-avatar
      class='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'>
    </tag-avatar>
  </div>
  <tag-tooltip
    tooltip-for='.tooltip-target'
    header='Scott Wright'>
    <div style="width: 480px; display: flex">
      <div>
          <tag-field label="Club" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="Aberdeen"></tag-field>
          <tag-field label="Number" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="15"></tag-field>
          <tag-field label="Position" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="Forward"></tag-field>
      </div>
      <div style="margin-left:50px;">
        <tag-field label="Appearances" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="55"></tag-field>
        <tag-field label="Goals" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="7"></tag-field>
        <tag-field label="Date of birth" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="8 Aug 1997"></tag-field>
      </div>
    </div>
  </tag-tooltip>`,
  },
  coreComponent_v3: {
    html: `<div style='text-align: center;'>
    <tag-avatar
      class='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'>
    </tag-avatar>
  </div>
  <tag3-tooltip
    tooltip-for='.tooltip-target'
    header='Scott Wright'>
    <div style="width: 480px; display: flex">
      <div>
          <tag-field label="Club" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="Aberdeen"></tag-field>
          <tag-field label="Number" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="15"></tag-field>
          <tag-field label="Position" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="Forward"></tag-field>
      </div>
      <div style="margin-left:50px;">
        <tag-field label="Appearances" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="55"></tag-field>
        <tag-field label="Goals" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="7"></tag-field>
        <tag-field label="Date of birth" label-style='{"width": "100px", "white-space": "nowrap", "font-weight": "bold"}' value="8 Aug 1997"></tag-field>
      </div>
    </div>
  </tag3-tooltip>`,
  },
  reactWrapper: {
    jsx: `<div>
  <div style={{textAlign: "center"}}>
    <TagAvatar
      className='tooltip-target'
      src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
      size='40px'
    />
  </div>
  <TagTooltip
    tooltipFor='.tooltip-target'
    header='Scott Wright'>
    <div style={{width: "480px", display: "flex"}}>
      <div>
          <TagField label="Club" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="Aberdeen" />
          <TagField label="Number" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="15" />
          <TagField label="Position" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="Forward" />
      </div>
      <div style={{marginLeft: "50px"}}>
        <TagField label="Appearances" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="55" />
        <TagField label="Goals" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="7" />
        <TagField label="Date of birth" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="8 Aug 1997" />
      </div>
    </div>
  </TagTooltip>
</div>`,
  },
  reactWrapper_v3: {
    jsx: `<CustomContentExample />`,
    parentJSX: `CustomContentExample = () => {
    return (
      <div>
        <div style={{textAlign: "center"}}>
          <TagAvatar
            key={Math.random()}
            className='tooltip-target'
            src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
            size='40px'
          />
        </div>
        <Tag3Tooltip
          tooltipFor='.tooltip-target'
          header='Scott Wright'>
          <div style={{width: "480px", display: "flex"}}>
            <div>
                <TagField label="Club" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="Aberdeen" />
                <TagField label="Number" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="15" />
                <TagField label="Position" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="Forward" />
            </div>
            <div style={{marginLeft: "50px"}}>
              <TagField label="Appearances" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="55" />
              <TagField label="Goals" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="7" />
              <TagField label="Date of birth" labelStyle={{width: "100px", whiteSpace: "nowrap", fontWeight: "bold"}} value="8 Aug 1997" />
            </div>
          </div>
        </Tag3Tooltip>
      </div>
    )
    };`,
  },
};

const SuppressArrow: Story = {
  title: 'Suppress Arrow',
  description: 'A tooltip with suppressed tippy arrow',

  coreComponent_v3: {
    html: `<div style='text-align: center;'>
  <tag-avatar
    class='tooltip-target'
    src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
    size='40px'>
  </tag-avatar>
</div>
<tag3-tooltip
  tooltip-for='.tooltip-target'
  header='Tooltip'
  content='Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dictum nisl blandit nunc maximus, ut placerat odio sodales. Donec fermentum massa id turpis tempor consequat. Nullam imperdiet auctor purus, ac convallis.'
  width='470px'
  background='dark'
  tippy-props='{"arrow": false}'>
</tag3-tooltip>`,
  },
  reactWrapper_v3: {
    jsx: `<SuppressArrowExample />`,
    parentJSX: `SuppressArrowExample = () => {
    return (
      <div>
        <div style={{textAlign: "center"}}>
          <TagAvatar
            className='tooltip-target'
            key={Math.random()}
            src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
            size='40px'
          />
        </div>
        <Tag3Tooltip
          tooltipFor='.tooltip-target'
          header='Tooltip'
          content='Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis dictum nisl blandit nunc maximus, ut placerat odio sodales. Donec fermentum massa id turpis tempor consequat. Nullam imperdiet auctor purus, ac convallis.'
          width='470px'
          background='dark'
          tippyProps={{arrow: false}} />
      </div>
    )
    };`,
  },
};

const PlacementKnobs: Knobs = {
  tippyProps: {
    editor: 'textbox',
    default: '{"placement": "top-start"}',
    delimiter: '\n    ',
  },
};

const PlacementKnobsReact: Knobs = {
  tippyProps: {
    editor: 'textbox',
    default: '{placement: "top-start"}',
    delimiter: '\n    ',
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const PlacementDemo: Story = {
  title: 'Custom Placement',
  description: 'A tooltip with custom tippy placement',

  coreComponent_v3: {
    html: `<div style='text-align: center;'>
      <tag-avatar
        class='tooltip-target'
        src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
        size='40px'>
      </tag-avatar>
    </div>
    <tag3-tooltip
      tooltip-for='.tooltip-target'
      header='Tooltip'
      width='200px'
      background='dark'{{...knobs}}>
      <div class="tooltip__container__content">
        For full details of available placement options <a style="color: white;" target="_blank" href="https://atomiks.github.io/tippyjs/v6/all-props/#placement">Click Here!</a>.
      </div>
    </tag3-tooltip>`,
    knobs: PlacementKnobs,
  },
  reactWrapper_v3: {
    jsx: `<PlacementExample />`,
    parentJSX: `PlacementExample = () => {
    return (
      <div>
        <div style={{textAlign: "center"}}>
          <TagAvatar
            className='tooltip-target'
            key={Math.random()}
            src='https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350'
            size='40px'
          />
        </div>
        <Tag3Tooltip
          tooltipFor='.tooltip-target'
          header='Tooltip'
          width='200px'
          background='dark'{{...knobs}}>
            <div className="tooltip__container__content">
              For full details of available placement options <a style={{color: "white"}} target="_blank" href="https://atomiks.github.io/tippyjs/v6/all-props/#placement">Click Here!</a>.
            </div>
        </Tag3Tooltip>
      </div>
    )
    };`,
    knobs: PlacementKnobsReact,
  },
};

export const TagToolTipDocs: Component = {
  type: 'component',
  name: 'tooltip',
  description: 'Renders a tooltip for a related element',
  mobileFriendly: false,
  popular: false,
  preRelease: 'beta',
  props: [
    {
      name: 'tooltipFor',
      description: 'The CSS selector for the source element for the tooltip',
      type: 'string',
    },
    {
      name: 'open',
      default: 'false',
      description: 'Whether the tooltip is open',
      type: 'boolean',
    },
    {
      name: 'width',
      description: 'The width of the tooltip',
      type: 'string',
    },
    {
      name: 'background',
      default: 'light',
      description: 'The type of the tooltip',
      type: 'light | dark',
    },
    {
      name: 'suppressArrow',
      default: 'false',
      description:
        'Deprecated in V3 - (use tippyProps: {"arrow": false} in v3).Whether to hide the tooltip arrow',
      type: 'boolean',
    },
    {
      name: 'position',
      default: 'auto',
      description:
        'Deprecated in V3 - (use tippyProps: {"placement":"value"} in v3). Where the tooltip should be positioned by default. If the default positioning takes the popover off the screen then the popover will be positioned as best as it can',
      type:
        'auto | auto-start | auto-end | bottom | bottom-start | bottom-end | top | top-start | top-end | left | left-start | left-end | right | right-start | right-end',
    },
    {
      name: 'dropShadowDisabled',
      default: 'false',
      description: 'Deprecated in V3. Defines whether the drop shadow is disabled on the tooltip',
      type: 'boolean',
    },
    {
      name: 'header',
      description: 'The heading of the tooltip',
      type: 'string',
    },
    {
      name: 'headerStyle',
      description: 'The style of the header',
      type: 'string',
    },
    {
      name: 'content',
      description: 'The content of the tooltip',
      type: 'string',
    },
    {
      name: 'contentStyle',
      description: 'The style of the content',
      type: 'string',
    },
    {
      name: 'containerStyle',
      description: 'The style of the container',
      type: 'string',
    },
    {
      name: 'tippyProps',
      default: '',
      description: 'V3 Only: Defines the tippy props.',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'string',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory, CustomContentStory, SuppressArrow, PlacementDemo],
};
